import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFullscreen2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFullscreen2"><Path d="M1.75 3.75V20.25H22.25V3.75H1.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFullscreen2;
